/** Días que la tarjeta del inicio queda oculta después de "Más tarde". */
export const IDENTITY_CLAIM_CARD_SNOOZE_DAYS = 7;
export const IDENTITY_CLAIM_ROUTE = '/identity-claim';
export const OWN_PASSWORD_PATTERN = /^(?=.*[a-z])[^\s]{8,}$/;
export const OWN_PASSWORD_MESSAGE =
  'La contraseña debe tener al menos 8 caracteres y debe incluir al menos UNA letra minúscula.';
export const postponedKey = (userId: number) =>
  `identity-claim-postponed-at-${userId}`;
export const noEmailKey = (userId: number) =>
  `identity-claim-no-email-${userId}`;
